import { combineReducers } from "redux";

import navigationReducer from "./navigation/reducers";
import authReducer from "@login/reducer/reducers";
import configReducer from "./config-store/reducers";
import deviceInfoReducer from "./devices/reducers";

import accountReducer from "app/modules/account-management/reducer/reducers";

import transferReducer from "app/modules/transfer/reducer/reducers";
import transfer247Reducer from "app/modules/transfer/transfer-247/reducer/reducers";
import transferCashByCodeReducer from "app/modules/transfer/transfer-cash-by-code/reducer/reducers";
import transferForeignReducer from "app/modules/transfer/transfer-foreign/reducer/reducers";
import transferLocalReducer from "app/modules/transfer/transfer-local/reducer/reducers";
import transStockReducer from "app/modules/transfer/transfer-stock/reducer/reducers";
import transCharityReducer from "app/modules/transfer/transfer-charity/reducer/reducers";

import topUpReducer from "app/modules/top-up/reducer/reducers";
import billingReducer from "app/modules/billings/reducer/reducers";
import autoTopUpReducer from "app/modules/auto-top-up/reducer/reducers";
import autoBillingReducer from "app/modules/auto-billings/reducer/reducers";

import termDepositListReducer from "app/modules/term-deposit/list-term-deposit/reducer/reducers";
import termDepositOpenReducer from "app/modules/term-deposit/term-deposit-open/reducer/reducers";
import termDepositTopUpReducer from "app/modules/term-deposit/term-deposit-top-up/reducer/reducers";
import termDepositStatementReducer from "app/modules/term-deposit/term-deposit-statement/reducer/reducers";

import cardReducer from "app/modules/card-manager/reducer/reducers";
import paymentCardReducer from "app/modules/card-manager/payment-card/reducer/reducers";

import beneReducer from "app/modules/beneficiaries/reducer/reducers";
import statementReducer from "app/modules/account-management/statement/reducer/reducers";
import transHistoryReducer from "app/modules/account-management/transaction-history/reducer/reducers";

import loyaltyReducer from "app/modules/loyalty/reducer/reducers";
import homeReducer from "app/modules/home/reducer/reducer";
import modalReducer from "app/modules/modal-management/reducer/reducer";

import changePasswordReducer from "app/modules/settings/change-password/reducer/reducers";


const rootReducer = combineReducers({
  navigation: navigationReducer,
  config: configReducer,
  home: homeReducer,
  auth: authReducer,
  account: accountReducer,
  deviceInfo: deviceInfoReducer,
  transfer: transferReducer,
  transfer247: transfer247Reducer,
  transferCashByCode: transferCashByCodeReducer,
  transferForeign: transferForeignReducer,
  transferLocal: transferLocalReducer,
  transferStock: transStockReducer,
  transferCharity: transCharityReducer,
  topUp: topUpReducer,
  billing: billingReducer,
  autoTopUp: autoTopUpReducer,
  autoBilling: autoBillingReducer,
  termDepositList: termDepositListReducer,
  termDepositOpen: termDepositOpenReducer,
  termDepositTopUp: termDepositTopUpReducer,
  termDepositStatement: termDepositStatementReducer,
  card: cardReducer,
  paymentCard: paymentCardReducer,
  beneficiaries: beneReducer,
  statement: statementReducer,
  transHistory: transHistoryReducer,
  loyalty: loyaltyReducer,
  modal: modalReducer,
  changePassword: changePasswordReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
